import React, { useEffect, useState } from "react";
import {
  Form,
  HyperLink,
  notification,
} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import { useDispatch } from "react-redux";
import { GetEachFormFields } from "../../components/_utils/formUtils";
import { useNavigate } from "react-router-dom";
import { singleUserFxn,updateUserFxn } from "./actions";
import {fetchSaleCategory} from "../category/actions";
import moment from "moment";
const EditReception = (props) => {
  const { getFieldValue,setFieldsValue } = props.form;
  let dispatch = useDispatch();
  const [receptionId, setReceptionId] = useState("");
  const [saleCategory, setSaleCategory] = useState([]);

  useEffect(() => {
    checkReceptionId();
  }, []);

  const checkReceptionId = async () => {
    let searchParams = new URLSearchParams(window.location.search);
    let id = searchParams.get("_id");
    if (id) {
      getSingleReception(id);
      setReceptionId(id);
    }
  };
  const getSingleReception = async (id) => {
    let { data, success } = await dispatch(singleUserFxn(id));
    console.log(data, "valdata")
    if (success) {
      setTimeout(() => {
        props.form.setFieldsValue({
          name: data.name,
          mobile: data.mobile,
          address: data.address,
          email: data.email,
          state: data.state,
          city: data.city,
          saleCategory: data.saleCategory,
        });
      }, 300);
      setTimeout(() => {
        if(data.gstType == "Registered"){
          setFieldsValue({gstIn: data.gstIn})
        }
      }, 400);
      
    }
  };
 

    const handleSubmit = (e) => {
      const {form} = props;
      e.preventDefault();

      form.validateFields(async (err, valData) => {
          if (!err) {

              valData._id = receptionId
            
              let x = await dispatch(updateUserFxn(valData));
              if (x && x.success) {
                  console.log(x, "valdata")
              }
          } else {
              if (err.name) {
                  notification.warning({
                      message: `Please enter Name`,
                  });
                  return;
              }

              if (err.email) {
                  notification.warning({
                      message: `Please enter Email`,
                  });
                  return;
                }
              if (err.saleCategory) {
                  notification.warning({
                      message: `Please enter Sale category`,
                  });
                  return;
                }

              notification.warning({
                  message: "Fill All Required Fields",
              });
          }
      });
  };

  const fetchSaleFrom = async () => {
    const { data } = await fetchSaleCategory({});
    setSaleCategory(data);
  };

  useEffect(() => {
    fetchSaleFrom();
  }, []);

  let inputTypes = {
    fields: [
      {
        key: "name",
        label: "Name",
        span: "col-md-4",
        placeholder: "Doctor Name",
        required: true,
      },
      {
        key: "email",
        label: "Email",
        type: "email",
        span: "col-md-4",
        placeholder: "Email",
        required: true,
      },
     
      {
        key: "mobile",
        label: "Mobile No",
        span: "col-md-4",
        placeholder: "Mobile No",
        required: true,
      },
      {
        key: "address",
        label: "Address",
        span: "col-md-4",
        placeholder: "Address",
        required: false,
        type: "textarea",
      },
      {
        key: "saleCategory",
        label: "Sale Category*",
        span: "col-md-4",
        placeholder: "Choose One",
        type: "select",
        options: saleCategory,
        showSearch: true,
        keyAccessor: (x) => x._id,
        valueAccessor: (x) => `${x.name}`,
        onChange: (x) => {
          props.form.setFieldsValue({
            saleCategory: x,
          });
        },
      },
    ],
  };
  return (
    <>
      <PageHeader title={"Edit Reception"}>
        <div className="card">
          <div className="card-body">
            <Form onSubmit={handleSubmit}>
              <div className="form-elements-wrapper">
                <div className={"row"}>
                  {inputTypes.fields.map((item, key) => {
                    return !item.hidden ? (
                      <div
                        className={`pb-3 ${item.span ? item.span : "col-md-6"}`}
                        key={key}
                      >
                        <GetEachFormFields {...props.form} item={item} />
                      </div>
                    ) : null;
                  })}
                </div>
              </div>

              <button type="submit" className="btn btn-gradient-primary me-2">
                Submit
              </button>
              <HyperLink
                className=" ms-4 btn btn-danger"
                link={"/company-list"}
              >
                Cancel
              </HyperLink>
            </Form>
          </div>
        </div>
      </PageHeader>
    </>
  );
};

export default Form.create()(EditReception);
